var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 114,
    viewBox: "0 0 1920 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 1920,
    height: 114,
    transform: "translate(-1602 -17528)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 1920,
    height: 1416.554,
    fill: "#fff8f9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    transform: "translate(1602 17528)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(-1602 -17527.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43592",
    "data-name": "Path 43592",
    d: "M144.664,37.666c256.086-54.046,504.678-35,741.315-1.028,59.161,8.493,117.576,17.922,175.167,27.374C1353.27,136.392,1643.66,71.03,1920,0V1311.337c-109.2-4.121-216.78-15.57-322.139-29.712-59.424-7.969-118.144-16.8-176.047-25.654-411.166-93.922-807.658,58.23-1171.21,127.4-81.2,15.6-165.286,26.435-250.6,33.175V75.01C43.1,61.288,91.134,48.76,144.664,37.666",
    transform: "translate(0 0.003)",
    fill: "#fff8f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBorder);
export default __webpack_public_path__ + "static/media/wave-border.f88adda178d10a63a7a99275a6f216b3.svg";
export { ForwardRef as ReactComponent };